import { Access, AccessOverview, AccessWizard } from 'projects/flow-gui-access/views/middlewares/access'

module.exports = [
  {
    path: '/access',
    exact: true,
    component: AccessOverview
  }, {
    path: '/access/wizard',
    exact: true,
    component: AccessWizard
  }, {
    path: '/access/wizard/:accessId/:service',
    exact: true,
    component: AccessWizard
  }, {
    path: '/access/:accessid',
    exact: true,
    component: Access
  }
]



// WEBPACK FOOTER //
// ./src/projects/flow-gui-access/routes/access.js